module.exports = __webpack_public_path__ + "static/media/blue-circle.b6f2767b.png";